import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, Label, CardHeader, Table, Collapse, Button, Modal, Input, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import './MyFarm.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { FaChevronUp, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import { useNavigate } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { flushSync } from "react-dom";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";

const MyFarm = ({ exportPropertyMapToKml,generatePropertyMapReportToKml,quickDetail, reportButtonVisible, generatePropertyMapReport, exportPropertyMapToPdf, biodiversity, sectionList, showHideRiskItems, showHideRiskMapItem, showRiskItems, mapDetails, setMapDetails, largeEnterpriseDetails }) => {

    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [loading, setLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(true); const [isIconUp, setIsIconUp] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    const mapView = useMemo(() => {
        return (
            <MapView
                itemModel={biodiversity}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}
                width={'100%'}>
            </MapView>
        )
    }, [biodiversity, mapDetails, largeEnterpriseDetails])

    const mapView1 = useMemo(() => {
        return (
            <MapView
                itemModel={biodiversity}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}
                width={'100%'} height={"80vh"}>
            </MapView>
        )
    }, [biodiversity, mapDetails, largeEnterpriseDetails])

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [])



    const [mapViewPopup, setMapViewPopup] = useState({ showMapViewPopup: false });
    const handleMapViewPopupClose = (event) => {
        setMapViewPopup({ showMapViewPopup: false });
    }
    const showFullMap = () => {
        setMapViewPopup({ showMapViewPopup: true });
    }

    const CustomToastWithLink = () => (
        <div>
            <p>The whole farm operation as you’ve mapped it will now appear here. You can select or de-select different categories by clicking on the tick boxes above the map.  if the map view is too cluttered.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };


    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4 ">
                <CardHeader className="card-header-dark-click" onClick={toggle}>
                    <Row>
                        <Col sm="11"><h5>My Farm&nbsp;&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-33" onClick={(e) => e.stopPropagation()} />
                        </h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-33"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on the summary page <a href="https://freshwaterfarmplan.co.nz/fwfp-support/summary-overview/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Col>
                        <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                    </Row>
                </CardHeader>
                <Collapse isOpen={isOpen}>
                    <CardBody>
                        {
                            loading ? <SpinnerContainer /> :
                                <div>
                                    <Row>
                                        <Col sm="8">
                                            <Row>
                                                {sectionList != undefined && sectionList != null && sectionList.map(item => (
                                                    <Col key={uuid()} sm="4">
                                                        <input type="checkbox" className="riskmapCheck" id={"chk_" + item.name} name={"chk_" + item.name} checked={item.checked}
                                                            onChange={(e) => showHideRiskMapItem(e, item)} />{" "}
                                                        {item.displayName}
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                        <Col sm="4">
                                            <Row>
                                                <Col sm="4">
                                                    {reportButtonVisible &&
                                                        <>
                                                            {generatePropertyMapReport ?
                                                                <Button id="btnSave" onClick={exportPropertyMapToPdf}
                                                                    color="primary"
                                                                    disabled
                                                                >
                                                                    <Row>
                                                                        <Col sm="9">
                                                                            <span>
                                                                                {' '}Generating
                                                                            </span>
                                                                        </Col>
                                                                        <Col sm="3">
                                                                            <Spinner size="sm" style={{ marginRight: "5px" }}>
                                                                                Generating...
                                                                            </Spinner>
                                                                        </Col>
                                                                    </Row>
                                                                </Button>
                                                                :
                                                                <Button id="btnSave" onClick={exportPropertyMapToPdf} color="primary">
                                                                    Print Map&nbsp;&nbsp;&nbsp;<img src="/images/PDF_icon.png" className="card_icon" ></img>
                                                                </Button>
                                                            }
                                                        </>
                                                    }
                                                </Col>
                                                <Col sm="4">
                                                    {reportButtonVisible &&
                                                        <>
                                                        {generatePropertyMapReportToKml ?
                                                            <Button id="btnSave" onClick={exportPropertyMapToKml}
                                                                    color="primary"
                                                                    disabled
                                                                >
                                                                    <Row>
                                                                        <Col sm="9">
                                                                            <span>
                                                                                {' '}Generating
                                                                            </span>
                                                                        </Col>
                                                                        <Col sm="3">
                                                                            <Spinner size="sm" style={{ marginRight: "5px" }}>
                                                                                Generating...
                                                                            </Spinner>
                                                                        </Col>
                                                                    </Row>
                                                                </Button>
                                                                :
                                                            <Button id="btnSave" onClick={exportPropertyMapToKml} color="primary">
                                                                    Export to KML
                                                                </Button>
                                                            }
                                                        </>
                                                    }
                                                </Col>
                                                <Col sm="4"><Button color="primary" onClick={showFullMap}>Show Full Size Map</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="4" >
                                        </Col>
                                        <Col sm="4" style={{ display: "none" }}>
                                            <input type="checkbox" className="riskmapCheck" id="showRiskItems" name="showRiskItems" checked={showRiskItems}
                                                onChange={(e) => showHideRiskItems(e)} />{" "}
                                            Show Risk Items Only
                                        </Col>
                                        <Col>
                                            <Table striped bordered hover style={{ tableLayout: 'fixed', width: '100%' }}>
                                                <thead style={{ background: 'darkgrey', textAlign: 'left' }}>
                                                    <tr>
                                                        <th style={{ width: '33%', padding: "0" }}> Total Area (ha) </th>
                                                        <th style={{ width: '33%', padding: "0" }}> Lease Area (ha) </th>
                                                        <th style={{ width: '33%', padding: "0" }}> Irrigated Area (ha) </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr key={1}>
                                                        <td> {quickDetail.totalArea}</td>
                                                        <td> {quickDetail.leaseArea}</td>
                                                        <td> {quickDetail.irrigatedArea}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: '5px' }}>
                                        <Col id='mapView'>
                                            <Row className="map-layer">
                                                <Col>
                                                    <Row>
                                                        <Col sm="8"></Col>
                                                        <Col sm="4">
                                                            <div className="map-item-edit-div">
                                                                <Label className="map-checkbox-label">Show Label</Label>
                                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {mapView}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                        }
                    </CardBody>
                </Collapse>
            </Card>

            <Modal dialogClassName="modal-height" style={{ maxWidth: '90vw', width: '100%' }} isOpen={mapViewPopup.showMapViewPopup} size="xl">
                <ModalHeader toggle={handleMapViewPopupClose} ></ModalHeader>
                <ModalBody>
                    <Row>
                        <Col id='mapView'>
                            {mapView1}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleMapViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>

        </div>
    )
}
export default MyFarm;